<template>
  <div>
    <v-navigation-drawer v-model="drawer" fixed right clipped app>
      <v-list>
        <template v-for="menuItem in menuItems">
          <v-list-group
            :key="menuItem.title"
            :prepend-icon="menuItem.icon"
            no-action
            v-if="$can('access', menuItem.caslSubject)"
          >
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{ menuItem.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list-item v-for="item in menuItem.items" :key="item.title" :href="item.url">
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-navigation-drawer v-model="left" temporary fixed></v-navigation-drawer>
  </div>
</template>

<script>
import { MIDDLEWARE_REACT } from "@/config";

export default {
  props: { value: { type: Boolean } },
  data() {
    return {
      left: false,
      drawer: this.value,
      menuItems: [
        {
          title: "Users",
          icon: "mdi-store",
          caslSubject: "Users",
          items: [
            {
              title: "List",
              url: "/options/users"
            }
          ]
        },
        {
          title: "Options",
          icon: "mdi-store",
          caslSubject: "Options",
          items: [
            {
              title: "Shops",
              url: MIDDLEWARE_REACT + "options/shops"
            },
            {
              // Migrated to React: the place now carries its timezone and its
              // parallel capacity, both read by the online booking engine.
              title: "Locations",
              url: MIDDLEWARE_REACT + "options/locations"
            },
            {
              title: "Currencies",
              url: "/options/currencies"
            },
            {
              title: "Currency Rates",
              url: "/options/currency-rates"
            },
            {
              // Migrated to React: the type now carries its duration and its
              // "bookable online" flag, which decide what the website offers.
              title: "Fitting Types",
              url: MIDDLEWARE_REACT + "options/fitting-types"
            },
            {
              title: "Fees",
              url: "/options/fees"
            },
            {
              title: "Iron Types",
              url: "/options/iron-types"
            },
            {
              title: "Tax Rates",
              url: "/options/tax-rates"
            }
          ]
        },
        {
          title: "Bexio",
          icon: "mdi-api",
          caslSubject: "Options",
          items: [
            {
              title: "Dashboard",
              url: "/bexio/dashboard"
            },
            {
              title: "Accounts",
              url: "/bexio/account"
            },
            {
              title: "Actions",
              url: "/bexio/actions"
            }
          ]
        }
      ]
    };
  },
  watch: {
    value: function() {
      this.drawer = this.value;
    },
    drawer: function() {
      this.$emit("input", this.drawer);
    }
  }
};
</script>
